import debugLib from 'debug';
import * as R from 'ramda';
import dash_api from '../../main/support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const debug = debugLib('PbaLiveviewActions');

const CreateSession = new ReduxAsyncAction('PBA_LIVEVIEW_SESSION_CREATE');
CreateSession.registerRequest((payload) => {
  debug('createSession payload: ', payload);
  return dash_api.post('/v1/pba-liveview/session', payload).then((res) => {
    debug('createSession response: ', res);
    return R.merge(
      {
        session_id: payload.session_id,
      },
      res.data
    );
  });
});
export const SESSION_CREATE = CreateSession.constants;
export const createSession = CreateSession.request;

const UpdateSession = new ReduxAsyncAction('PBA_LIVEVIEW_SESSION_UPDATE');
UpdateSession.registerRequest((session_id, payload) => {
  debug('UpdateSession session_id: ', session_id, ' payload: ', payload);
  return dash_api.put(`/v1/pba-liveview/session/${session_id}`, payload).then((res) => {
    debug('UpdateSession response: ', res);
    return R.merge(
      {
        session_id: payload.session_id,
      },
      res.data
    );
  });
});
export const SESSION_UPDATE = UpdateSession.constants;
export const updateSession = UpdateSession.request;

const GetSessionEvents = new ReduxAsyncAction('PBA_LIVEVIEW_GET_SESSION_EVENTS');
GetSessionEvents.registerRequest((session_id) => {
  debug('GetSessionEvents session_id: ', session_id);
  return dash_api.get(`/v1/pba-liveview/session/${session_id}/events`).then((res) => {
    debug('GetSessionEvents response: ', res);
    return res.data;
  });
});
export const GET_SESSION_EVENTS = GetSessionEvents.constants;
export const getSessionEvents = GetSessionEvents.request;

export const LOAD_EVENTS = 'PBA_LIVEVIEW_LOAD_EVENTS';
export function loadEvents() {
  return {
    type: LOAD_EVENTS,
  };
}
